import { useContext } from "react";

import { NO_CONTEXT_VALUE_ERROR } from "../utils";
import { AuthContext } from "./AuthContext";

export const useAuthContext = () => {
  const contextValue = useContext(AuthContext);

  if (!contextValue) {
    throw new Error(NO_CONTEXT_VALUE_ERROR("AuthContext", "useAuthContext"));
  }
  return contextValue;
};

export const useAuthUser = () => {
  const contextValue = useAuthContext();

  if (!contextValue.user) {
    throw new Error(NO_CONTEXT_VALUE_ERROR("AuthContext", "useAuthUser"));
  }
  return contextValue.user;
};

export const useCompanyOverride = () => {
  const contextValue = useContext(AuthContext);

  if (!contextValue) {
    throw new Error(NO_CONTEXT_VALUE_ERROR("AuthContext", "useCompanyOverride"));
  }
  return contextValue.companyContext;
};

/*
 * Returns current company info.
 * By default, it is company returned by /self.
 * But it can be overridden in admin panel.
 */
export const useCurrentCompany = () => {
  const contextValue = useContext(AuthContext);

  if (!contextValue) {
    throw new Error(NO_CONTEXT_VALUE_ERROR("AuthContext", "useCurrentCompany"));
  }
  if (!contextValue.companyContext.currentCompany) {
    throw new Error("Current company in undefined!");
  }

  return contextValue.companyContext.currentCompany;
};
